import React from 'react';
import { useResponsive } from './useResponsive';

const withResponsive = <P extends object>(
  MobileComponent: React.ComponentType<P>,
  DesktopComponent: React.ComponentType<P>
) => {
  const ResponsiveComponent = (props: P) => {
    const isMobile = useResponsive();
    return isMobile ? <MobileComponent {...props} /> : <DesktopComponent {...props} />;
  };

  return ResponsiveComponent;
};

export default withResponsive;
